<script>
export default {
  props: {
    title: {
      type: String,
      required: false,
      default: ""
    },
    subtitle: {
      type: String,
      required: false,
      default: ""
    },
    size: {
      type: String,
      required: false,
      default: "sm"
    }
  }
};
</script>

<template>
  <transition name="fade" mode="out-in">
    <div class="modal" @click="$emit('close')">
      <div class="modal-box" :class="size" @click.stop>
        <div class="modal-header with-border-bottom">
          <div class="modal-title">
            <span v-html="title"></span>
            <slot name="header" />
          </div>
          <div class="modal-subtitle" v-html="subtitle"></div>
        </div>

        <div class="modal-body">
          <slot name="body" />
        </div>

        <div class="modal-footer">
          <slot name="footer" />
        </div>
      </div>
    </div>
  </transition>
</template>

<style scoped>
.modal {
  position: fixed;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.8);
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 10;
}

.modal-header {
  border-bottom: 1px solid #eee;
}

.modal-body {
  display: flex;
  flex-direction: column;
  margin-top: 10px;
  max-height: calc(100vh - 300px) !important;
  overflow-y: auto;
}

.modal-footer {
  margin-top: 15px;
  padding-top: 5px;
  border-top: 1px solid #eee;
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  justify-content: flex-end;
}

.modal-box {
  background: #fff;
  width: 800px;
  border-radius: 4px;
  max-height: 90%;
  padding: 20px;
}

.modal-box.lg {
  width: 800px;
}

.modal-box.md {
  width: 600px;
}

.modal-box.sm {
  width: 400px;
}

.modal-title {
  font-size: 20px;
  margin-bottom: 0 !important;
  color: var(--purple) !important;
  font-weight: 700;
}

.modal-subtitle {
  font-size: 14px;
  margin-bottom: 10px;
}

/* SCROLLBAR */

.modal-section.with-border-bottom {
  border-bottom: 1px solid #eee;
}

.modal-section.with-border-top {
  border-top: 1px solid #eee;
}

.modal-box::-webkit-scrollbar-button,
.modal-body::-webkit-scrollbar-button {
  display: hidden;
  height: 0;
  border-radius: 0px;
}

.modal-box::-webkit-scrollbar-thumb,
.modal-body::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0.2);
  border-radius: 5px;
}

.modal-box::-webkit-scrollbar-thumb:hover,
.modal-body::-webkit-scrollbar-thumb:hover {
  background-color: rgba(0, 0, 0, 0.3);
}

.modal-box::-webkit-scrollbar-track,
.modal-body::-webkit-scrollbar-track {
  background-color: transparent;
}

.modal-box::-webkit-scrollbar,
.modal-body::-webkit-scrollbar {
  width: 5px;
  position: absolute;
  left: -5px;
}

/* SCROLLBAR */

@media (max-width: 960px) {
  .modal-box {
    width: 80% !important;
    max-height: 85%;
  }

  .modal-body {
    max-height: calc(100vh - 280px) !important;
    word-break: break-word;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/_Shared/Modal.vue